import _ from 'lodash'
import * as mutationTypes from './mutation-types'

const UI = {
  state() {
    return {
      modalVisible: false,
      lastSelection: false,
    }
  },

  getters: {
    // Returns lastSelection if part of the visible result set, otherwise the first result
    activeSelection: (
      { lastSelection },
      _getters,
      _rootState,
      { searchResults }
    ) => {
      const defaultSelection = searchResults[0] || {}

      if (!lastSelection || !lastSelection.id) {
        return defaultSelection
      }

      return _.find(searchResults, lastSelection) || defaultSelection
    },
    isSelected:
      (state, { activeSelection }) =>
      (item) => {
        return activeSelection.id && _.isMatch(item, activeSelection)
      },
    modalVisible: (state) => state.modalVisible,
  },

  mutations: {
    [mutationTypes.TOGGLE_MODAL_VISIBLE](state) {
      state.modalVisible = !state.modalVisible
    },
    [mutationTypes.SET_LAST_SELECTION](state, lastSelection) {
      state.lastSelection = lastSelection
    },
  },

  actions: {
    moveSelectionDown({
      commit,
      state: { lastSelection },
      getters: { searchResults },
    }) {
      const selectionIndex = Math.max(
        0,
        _.findIndex(searchResults, lastSelection)
      )
      const newIndex =
        selectionIndex < searchResults.length - 1 ? selectionIndex + 1 : 0

      commit(mutationTypes.SET_LAST_SELECTION, searchResults[newIndex])
    },
    moveSelectionUp({
      commit,
      state: { lastSelection },
      getters: { searchResults },
    }) {
      const selectionIndex = Math.max(
        0,
        _.findIndex(searchResults, lastSelection)
      )
      const newIndex =
        selectionIndex > 0 ? selectionIndex - 1 : searchResults.length - 1

      commit(mutationTypes.SET_LAST_SELECTION, searchResults[newIndex])
    },
    toggleModal({ commit, state }) {
      commit(mutationTypes.TOGGLE_MODAL_VISIBLE)
      if (!state.modalVisible) {
        commit(mutationTypes.SET_CURRENT_QUERY_TEXT, '')
      }
    },
  },
}

export default UI
